import 'whatwg-fetch'
import { setLoading, setFinished, setInitial } from './LoadingButton'

export default () => {
  const forms = document.querySelectorAll('.js-form')
  if (forms.length < 1) return // For each form...
  ;[...forms].forEach(form => {
    form.addEventListener('submit', e => {
      e.preventDefault()

      // Set button to loading
      const button = form.querySelector('.c-button')
      setLoading(button)

      // Stop here if form isn't valid
      if (!form.checkValidity()) return

      // Send the form
      sendForm(form)
        .then(handleFetch)
        .then(r => {
          if (r.error) {
            setInitial(button)
            return
          }

          // Check if the form contains checkboxes for leaflets
          if (form.classList) {
            if (form.classList.contains('leaflets-form')) {
              r.action = r.action + checkForLeaflets(form)
            }
          }

          setFinished(button)
          sendGTMEvent(form)
          setTimeout(() => {
            window.location = r.action
            setInitial(button)
            resetForm(form)
          }, 1000)
        })
        .catch(e => {
          console.error(e)
          setInitial(button)
          window.alert(
            'Het formulier is niet verzonden, dit kan komen doordat het bijgevoegde bestand te groot is. Probeer het opnieuw.'
          )
        })
    })
  })

  // pass a query param for each leaflet that has been checked
  const checkForLeaflets = form => {
    let params = '?'
    const checkBoxes = [...form.querySelectorAll("input[type='checkbox']")]
    ;[...checkBoxes].forEach(checkbox => {
      if (checkbox.checked) {
        params = `${params}${checkbox.value}=true&`
      }
    })
    return params
  }

  /**
   * Send form
   */
  const sendForm = form =>
    window.fetch('/wordpress/wp-admin/admin-ajax.php?action=send_form', {
      credentials: 'same-origin',
      method: 'post',
      body: new window.FormData(form)
    })

  /**
   * Reset form
   */
  const resetForm = form => form.reset()

  /**
   * Handle fetch
   */
  const handleFetch = r => {
    if (!r.ok) {
      const error = {
        error:
          'Kan formulier niet versturen. Probeer het a.u.b. opnieuw of neem contact met ons op.'
      }
      return error
    } else {
      return r.json()
    }
  }

  const sendGTMEvent = form => {
    window.dataLayer = window.dataLayer || []
    let data = {
      event: 'formSent',
      form:
        form.querySelector("input[name='form_id']") !== undefined &&
        form.querySelector("input[name='form_id']") !== null
          ? form.querySelector("input[name='form_id']").value
          : 'Onbekend'
    }
    window.dataLayer.push(data)
  }
}



// WEBPACK FOOTER //
// ./src/js/modules/SendForm.js